module.exports = __webpack_public_path__ + "static/media/Eyebrows_black.d2665714.svg";